module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paytitle":"Payment solutions for all moments of purchase"},"es":{"paytitle":"Soluciones de pago para todos los momentos de compra"}}')
  delete Component.options._Ctor
}
